import type { JSX } from "react";
import { useAuth } from "../../hooks/use-auth";
import {
  AccessControl,
  type AppResource,
} from "../../permissions/access-control";
import { AccessDeniedPage } from "./access-denied-page";

type ProtectedResourceRouteProps = {
  resource: AppResource;
  children: JSX.Element;
  title?: string;
  description?: string;
};

export function ProtectedResourceRoute({
  resource,
  children,
  title,
  description,
}: ProtectedResourceRouteProps) {
  const { user } = useAuth();
  const canAccess = AccessControl.canView(resource, user?.role);

  if (canAccess) {
    return children;
  }

  return <AccessDeniedPage title={title} description={description} />;
}
